import { createAction } from 'redux-actions';
import { CLEAR_COMMUNICATOR_STATE } from '../constants/actionTypes';
export const clearCommunicatorState = createAction(CLEAR_COMMUNICATOR_STATE);